export default __webpack_public_path__ + "bluelights.mp3";